import { render, staticRenderFns } from "./CompensationTemplate.html?vue&type=template&id=cb4f4020&scoped=true&external"
import script from "./Compensation.vue?vue&type=script&lang=js"
export * from "./Compensation.vue?vue&type=script&lang=js"
import style0 from "./Compensation.vue?vue&type=style&index=0&id=cb4f4020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4f4020",
  null
  
)

export default component.exports